import { action, computed, observable } from 'mobx';

import httpFacade from 'http/httpFacade';
import Log from 'helpers/log';
import {
  FeedbackReport,
  FeedbackReportReqParams,
} from 'http/Api/Feedback/types';
import { PromiseService } from 'services/PromiseService';

import { SortProperty } from '../types';

class FeedbackReportStore {
  @observable report: FeedbackReport[] = [];
  @observable sortProperty: SortProperty | null = null;

  @observable private _promiseService = new PromiseService();

  @action
  getReport = async (params: FeedbackReportReqParams) => {
    try {
      const { data } = await this._promiseService.add(() =>
        httpFacade.feedback.fetchReport(params),
      );

      this.report = data;
    } catch (error) {
      Log.warn(error);
    }
  };

  @action.bound
  changeSortProperty(sortProperty: SortProperty | null) {
    this.sortProperty = sortProperty;
  }

  @computed
  get loading() {
    return this._promiseService.isPending || !this._promiseService.isCompleted;
  }
}

export default FeedbackReportStore;
